// sagas/closureSaga.js
import { takeLatest, call, put } from "redux-saga/effects";
import { createDemoRequest } from "../../../services/accIqService";
import {
  SUBMIT_DEMO_REQUEST,
  submitDemoSuccess,
  submitDemoFailure
} from "../actions/demoRequestActions";
import { fetchClosureAgent } from "../../../services/accIqService";

// Saga function
function* handleDemoRequestSubmission(action) {
  try {
    const response = yield call(
        createDemoRequest, 
        // action.payload.requestType,
        // action.payload.roundOfDemo,
        // action.payload.sellerAccountName,
        // action.payload.buyerAccountName,
        action.payload.sellerAccountWebsite,
        action.payload.buyerAccountWebsite,
        // action.payload.sellerIndustry,
        // action.payload.buyerIndustry,
        // action.payload.noOfAccounts,
        // action.payload.noOfUsers,
        // action.payload.accountType,
        action.payload.demoDateTime,
        action.payload.question,
        // action.payload.salesPersonNameAndDesignation,
        action.payload.lead_id,
        // action.payload.icpNameAndDesignation,
        action.payload.clientLinkedinUrl,
        action.payload.productListCsv,
        action.payload.csvData,
        
        action.payload.exploringTools,
        // action.payload.keyChallenges,        
        // action.payload.otherChallenge,
        action.payload.kpi,
        action.payload.growthFocus,
        action.payload.salesTeamSize,
        // action.payload.keyAccountsCount,
        // action.payload.currentTools,
        // action.payload.otherTool,
        action.payload.decisionMakers,
        
    );
    yield put(submitDemoSuccess(response || "Demo request not submitted."));
  } catch (error) {
    yield put(submitDemoFailure(error.error));
  }
}

export function* watchDemoRequestSubmission() {
  yield takeLatest(SUBMIT_DEMO_REQUEST, handleDemoRequestSubmission);
}